import { render, staticRenderFns } from "./TaxonomyDetails.vue?vue&type=template&id=5402fb4e&"
import script from "./TaxonomyDetails.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports